import { Box, Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';

export interface IFeatureCardProps {
  icon: string;
  title: string;
  description: string;
  descriptionWidth?: number;
}

export const FeatureCard = ({
  icon,
  title,
  description,
  descriptionWidth = 200,
}: IFeatureCardProps) => {
  return (
    <Box
      flex={1}
      display="flex"
      flexDirection="column"
      alignItems="center"
      padding={16}
      width={272}
      minHeight={160}
    >
      <img src={icon} width={56} height={56} style={{ marginBottom: 16 }} />
      <Text fontSize={18} bold textAlign="center" color={Colors.primary_500} marginBottom={8}>
        {title}
      </Text>
      <Text fontSize={14} textAlign="center" width={descriptionWidth}>
        {description}
      </Text>
    </Box>
  );
};
